import { connect } from 'react-redux';
import decorate from '../../../utils/decorate';
import { request as moveList } from '../../../modules/sports/actions/move-list';
import SportGeneral from './SportGeneral.jsx';

function mapStateToProps(state) {
    return {
        sports: state.sports.get('items'),
        moveStatus: state.sports.getIn([ 'move', 'state' ])
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onMoveSportsRequest: (sport, list) => {
            dispatch( moveList(sport,list) );
        }
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    SportGeneral
);
